export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12113.e9f01e6c.jpg";